export const numberToCurrentcy = (ammount: number) =>
    ammount.toLocaleString('en-US', {
        minimumFractionDigits: 2
    });
